import { debounce } from 'lodash';
import { keyCode, searchHelperType } from './search.helper';
import { keywordFilter } from './search.history';

const SEARCH_DELAY = 100;

export default class SearchForm {
  constructor({
    $wrapper,
    $form,
    $input,
    $btnResetInput,
    instantSearch = null,
    searchHistory = null,
    openCallback = null,
    closeCallback = null,
  }) {
    this.$wrapper = $wrapper;
    this.$form = $form;
    this.$input = $input;
    this.$btnResetInput = $btnResetInput;
    this.searchHistory = searchHistory;
    this.instantSearch = instantSearch;
    this.hideInputOnDefault = Ridi.globals.isMobile && !$('#books_header').hasClass('search_extend');
    this.openCallback = openCallback ? openCallback.bind(this) : openCallback;
    this.closeCallback = closeCallback ? closeCallback.bind(this) : closeCallback;
    this.setEvents();
  }

  isOpen() {
    return this.$wrapper.hasClass('open');
  }

  getHelperType() {
    if (this.instantSearch && this.instantSearch.isOpen()) {
      return searchHelperType.INSTANT;
    }
    if (this.searchHistory && this.searchHistory.isOpen()) {
      return searchHelperType.HISTORY;
    }

    return searchHelperType.NONE;
  }

  setEvents() {
    this.$btnResetInput.click(e => {
      e.preventDefault();
      if (!this.isOpen()) this.open();
      this.reset();
    });

    this.$input
      .on('touchend', e => {
        if (!this.isOpen()) {
          e.preventDefault();
          this.$input.focus();
          setTimeout(() => {
            this.open();
          }, 0);
        }
      })
      .on('click', e => {
        e.preventDefault();
        this.open();
      })
      .keyup(debounce(this.onKeyup.bind(this), SEARCH_DELAY))
      .keydown(e => {
        switch (this.getHelperType()) {
          case searchHelperType.INSTANT:
            if (e.which === keyCode.ENTER) {
              e.preventDefault();
              this.$form.submit();
              return;
            }
            this.instantSearch.keyboardAction(e);
            break;
          case searchHelperType.HISTORY:
            if (e.which === keyCode.ENTER) {
              const target_search_url = this.searchHistory.getTargetSearchUrl();
              if (target_search_url !== undefined) {
                e.preventDefault();
                window.location.href = target_search_url;
              }
              return;
            }
            this.searchHistory.keyboardAction(e);
            break;
          default:
            if (e.which === keyCode.ENTER) {
              e.preventDefault();
              this.$form.submit();
            }
            break;
        }
      });

    this.$form.on('submit', e => {
      e.stopPropagation();
      const keyword = keywordFilter(this.$input.val());
      this.$input.val(keyword);
      if (this.searchHistory) this.searchHistory.add(keyword);
      if (this.instantSearch) return this.instantSearch.openSelectedLink();
      return true;
    });

    if (this.searchHistory) {
      this.searchHistory.bindOnKeywordClick(e => {
        e.preventDefault();
        const $eventTarget = $(e.target);
        this.$input.val($eventTarget.text());
        this.$form.submit();
      });
    }

    if (Ridi.globals.isPc || Ridi.globals.isTablet) {
      $('html').on(Ridi.globals.isPc ? 'click' : 'touchstart', e => {
        if (!this.$form[0]) {
          return;
        }
        const $eventTarget = $(e.target);

        const isTargetContainedInForm = this.$form[0].contains(e.target);
        const isTargetContainedInWrapper = this.$wrapper[0].contains(e.target);
        // If a search history has been removed, the target is not contained in the body anymore
        const isRemovedElement = !document.body.contains(e.target);

        if (
          !(
            isTargetContainedInForm
            || isTargetContainedInWrapper
            || isRemovedElement
          ) && this.isOpen()
        ) {
          e.preventDefault();
          this.close();
        }
      });
    }

    if (Ridi.globals.isMobile) {
      this.$wrapper.on('click touchstart', e => {
        if (e.target !== e.currentTarget) return;
        e.preventDefault();
        this.close();
      });
    }
  }

  onKeyup(e) {
    e.preventDefault();
    const keyword = this.$input.val().trim();
    if (!keyword.length) {
      this.reset();
      if (this.searchHistory) this.searchHistory.open();
      return;
    }
    this.$btnResetInput.show();
    if (this.searchHistory) this.searchHistory.close();
    if (this.instantSearch) this.instantSearch.get(keywordFilter(keyword));
  }

  open() {
    if (this.searchHistory) this.searchHistory.open();
    if (this.instantSearch) {
      this.instantSearch.open();
      this.$input.trigger('keyup');
    }

    if (!this.isOpen()) {
      this.$wrapper.addClass('open');
      if (this.openCallback) this.openCallback();
    }
  }

  close() {
    if (this.hideInputOnDefault) {
      this.$input.val(this.$input.data('user-keyword'));
      this.instantSearch.reset();
    } else {
      this.$btnResetInput.hide();
    }
    this.$input.blur();
    if (this.instantSearch) this.instantSearch.close();
    if (this.searchHistory) this.searchHistory.close();
    this.$wrapper.removeClass('open');
    if (this.closeCallback) this.closeCallback();
  }

  reset() {
    this.$input.val('');
    if (this.instantSearch) this.instantSearch.reset();
    this.$btnResetInput.hide();
    if (this.searchHistory) this.searchHistory.open();
    this.$input.focus();
  }
}



// WEBPACK FOOTER //
// ./common/search.form.js